export default __webpack_public_path__ + "static/challenge-463bcb3a5cc0f6bd632517ac4c31d956.webp";